// src/components/common/SplashLoadingScreen.js
// 76차: 신규 생성 — 네이티브 스플래시(app.config.js의 splash-icon.png + backgroundColor)가
// 사라진 직후 폰트/인증 로딩 동안 보여주던 화면이 배경색만 같고 로고·태그라인 없는
// 맨 스피너였음 — "스플래시가 잠깐 나왔다가 빙글빙글 화면으로 바뀐다"는 사용자 피드백의
// 원인. design_handoff_unlock/README.md의 스플래시 스펙(로고 + UNLOCK 워드마크 + 태그라인
// "방탈출의 모든 것, 하나의 열쇠로" + 하단 골드 스피너)을 그대로 적용해 네이티브 스플래시와
// 시각적으로 끊기지 않게 이어지도록 함. App.js(폰트 로딩/인증 로딩)와 navigation/index.js
// (AppNavigator 로딩)에서 공통으로 사용.
// fontsReady=false(App.js의 커스텀 폰트 로딩 게이트 전용)일 땐 워드마크에 FONTS.brand를
// 적용하지 않음 — 그 시점엔 아직 폰트가 로드되기 전이라 시스템 폰트로 그렸다가 로드 완료
// 직후 폰트가 바뀌는 깜빡임이 생기기 때문(72차 주석에서 이미 지적된 문제, 재도입 방지).
// 77차: design 폴더 스펙 재적용 — 로고를 실제 스펙 사이즈(118 근사치)로 키우고, 워드마크
// 색을 크림(COLORS.text)에서 스펙대로 골드(COLORS.gold, 그라디언트는 MaskedView 의존성이
// 없어 단색으로 근사)로, 하단 스피너를 기본 ActivityIndicator 대신 디자인의 `unlockSpin`
// 회전 아크(react-native-svg + reanimated, 둘 다 기존 의존성)로 교체. 배경의 미세 대각
// 스트라이프 텍스처(opacity 3.5%)는 육안 차이가 거의 없어 생략.
// 78차: claude.ai/design 프로젝트에서 실제 텍스처 에셋(splash-texture.png, 45° 골드
// 스트라이프, 160px 시임리스 타일)을 가져와 생략했던 부분 적용 — resizeMode="repeat"로
// 전체 화면에 타일링, opacity는 스펙값(~4%)으로 아주 옅게.
// 79차: 빌드 5(TestFlight) 실기기 재신고 — "로고만 잠깐 보이고 기존 스플래시로 넘어간다".
// 원인은 네이티브 스플래시(app.config.js, splash-icon.png)와 이 화면의 로고 크기/위치가
// 서로 달랐던 것 — splash-icon.png는 1024x1024 캔버스에 로고가 748px(≈75%)를 채우는데,
// 네이티브가 이 이미지를 imageWidth:200으로 축소해 화면 정중앙에 그리면 실제 로고 시각
// 크기는 ≈150px. 반면 이 화면은 LogoMark size=92를 워드마크·태그라인과 함께 세로로 쌓아
// "block 전체"를 화면 중앙에 놓고 있어서, 로고 자체의 크기(92 vs 150)도 작고 위치도
// (아래 형제 요소들 때문에) 화면 정중앙보다 위로 밀려 있었음 — 네이티브가 사라지는 순간
// 로고가 갑자기 작아지며 위로 튀어오르고 워드마크/태그라인/스피너가 동시에 팝업하는
// 것으로 체감됨. 로고를 네이티브와 동일한 ≈150px + 화면 정중앙 절대위치로 고정하고,
// 워드마크/태그라인은 그 아래 절대위치로 배치(로고 자신의 중앙정렬에 영향 안 줌)해
// 네이티브→JS 전환 시 로고 크기·위치가 그대로 유지되도록 함.
import React, { useEffect, useRef, useState } from 'react';
import { View, Text, Image, StyleSheet, useWindowDimensions, Animated } from 'react-native';
// 80차 계속: [성능 수정] PICK 광고(원격 이미지)만 expo-image로 — 디스크 캐시가 없는 기본
// Image라 스플래시(앱 켤 때마다)가 뜰 때마다 매번 재다운로드되고 있었음. 로고 텍스처는
// require()된 로컬 번들 자산이라 캐싱 대상이 아니라 그대로 둠.
import { Image as ExpoImage } from 'expo-image';
import { LogoMark } from './AppHeader';
import { COLORS } from '../../constants/theme';
import { getActivePickStoreEvents } from '../../services/eventService';

// 80차 후속: [디자인 변경] 하단 회전 스피너 제거(사용자 요청) — 로딩 인디케이터 없이
// 로고+텍스트+PICK 광고만으로 구성. react-native-svg/reanimated 의존 코드도 이
// 스피너 전용이라 함께 정리.
// 80차 후속: [버그 수정 3건, 실기기(TestFlight) 재신고] (1) 네이티브→JS 전환 시 로고
// 위치가 튀는 문제 — React Native 기본 Animated로 "네이티브와 같은 정중앙"에서 시작해
// 최종 위치로 슬라이드하는 연출로 전환(아래 SplashLoadingScreen 본문 주석 참고).
// (2) PICK 광고가 모바일에서 너무 작다는 신고 — 폭 35%→70%(높이는 16:9 비율이라 자동
// 으로 같이 2배). (3) 광고 체감 노출시간이 1초 미만이라는 신고 — 최소 홀드 시간
// 3초→5초로 연장.

// 80차 후속: [버그 수정, 실기기 디버그 텍스트로 확정] 79차가 "LOGO_SIZE=150이 네이티브의
// 실제 로고 크기(≈150px)와 일치한다"고 계산했던 것은, LogoMark의 SVG 내부 구조(size prop은
// 100 viewBox 전체 크기이고, 실제로 보이는 링은 그 중 72%만 차지 — Rect x=14,width=72)를
// 빠뜨린 계산이었음 — size=150을 그대로 넘기면 실제 보이는 링은 150×0.72=108dp(물리
// 292px)로, 네이티브(≈391px)보다 훨씬 작게 렌더링되고 있었음(에뮬레이터에 디버그 텍스트를
// 심어 LOGO_SIZE=150/PixelRatio=2.625가 정확히 읽히는데도 실측 크기가 여전히 작은 것으로
// 확인 — 빌드 파이프라인 문제가 아니라 이 계산 자체의 문제였음). 목표 링 크기(네이티브
// 실측 391px ÷ 2.625 ≈ 149dp)를 얻으려면 size = 149 ÷ 0.72 ≈ 207이 되어야 함.
// 80차 후속: [디자인 변경] 로고·제목·부제를 전부 10%씩 축소(사용자 요청) — 207*0.9.
const LOGO_SIZE = 186;

// 80차 후속: [버그 수정] SplashLoadingScreen은 App.js(폰트로딩 게이트 → 인증로딩 게이트)와
// navigation/index.js에서 각각 별개 컴포넌트로 렌더돼, 부팅 과정에서 이 컴포넌트가
// 여러 번 마운트/언마운트될 수 있음(각 게이트를 통과할 때마다 새 인스턴스) — 컴포넌트
// state로만 캐시하면 그때마다 PICK 이미지를 다시 조회해야 해서, 먼저 뜬 게이트에서
// 이미 받아온 이미지를 다음 게이트가 이어받지 못하고 광고가 늦게 뜨거나 아예 못 뜰 수
// 있었음 — 모듈 스코프 캐시(앱 프로세스 생존 기간 내내 유지)로 한 번만 조회하고
// 이후 마운트는 즉시 재사용하도록 함.
// 80차 후속: [버그 수정] "제목 페이드인 애니메이션을 없애도 광고가 여전히 늦게 뜬다"는
// 재신고 — 진짜 원인은 애니메이션이 아니라 getActivePickStoreEvents() 자체가 stores
// 컬렉션 전체 + events 컬렉션 전체를 순차로 두 번 조회하는 무거운 쿼리인데, 그 조회
// 시작 시점이 "SplashLoadingScreen이 처음 마운트되고 useEffect가 도는 시점"까지
// 미뤄져 있었던 것 — React 마운트/커밋/effect flush를 다 기다린 뒤에야 네트워크
// 요청이 시작되니 그만큼 고스란히 지연이 쌓임. 이 모듈이 로드되는 즉시(컴포넌트가
// 마운트되기 전, 최상단에서) 조회를 시작하도록 끌어올려 그 대기 시간을 제거.
let pickAdCache = null; // { url: string|null } — 조회 완료 후 채워짐
const pickAdFetchPromise = getActivePickStoreEvents()
  .then((events) => {
    const withImage = (events || []).filter((e) => e.imageUrl);
    const url = withImage.length > 0
      ? withImage[Math.floor(Math.random() * withImage.length)].imageUrl
      : null;
    pickAdCache = { url };
    return url;
  })
  .catch(() => { pickAdCache = { url: null }; return null; });

function usePickAdImage() {
  const [imageUrl, setImageUrl] = useState(pickAdCache?.url ?? null);
  useEffect(() => {
    if (pickAdCache) return; // 이미 조회 완료함(위 모듈 스코프 promise가 먼저 끝난 경우)
    let cancelled = false;
    pickAdFetchPromise.then((url) => { if (!cancelled) setImageUrl(url); });
    return () => { cancelled = true; };
  }, []);
  return imageUrl;
}

// 80차 후속: [기능 추가] "광고가 뜨기도 전에 화면이 넘어간다"는 신고 — App.js의
// 폰트로딩 게이트(최소 2초 타이머)와 인증로딩 게이트가 서로 독립적이라, 둘 다 빨리
// 끝나면(캐시된 폰트/세션) 이 광고 이미지 요청이 응답하기도 전에 스플래시가 끝나버릴
// 수 있었음 — 앱 부팅 시점(이 모듈이 처음 로드되는 시점, App.js가 가장 먼저 import함)을
// 기준으로 최소 3초는 어떤 게이트도 통과 못 하게 하는 공유 타이머. 여러 게이트가 각자
// 이 훅을 불러도 전부 같은 절대 시각(APP_BOOT_TIME)을 기준으로 계산하므로 순서·중복
// 마운트와 무관하게 "부팅 후 최소 3초"가 정확히 보장됨.
export const APP_BOOT_TIME = Date.now();
export function useMinSplashHold(ms = 3000) {
  const [elapsed, setElapsed] = useState(() => Date.now() - APP_BOOT_TIME >= ms);
  useEffect(() => {
    if (elapsed) return;
    const remaining = Math.max(0, APP_BOOT_TIME + ms - Date.now());
    const t = setTimeout(() => setElapsed(true), remaining);
    return () => clearTimeout(t);
  }, [elapsed, ms]);
  return elapsed;
}

// 80차 후속: [디자인 변경] 사용자가 그려준 최종 구조로 재구성 —
//   공백 20%(화면 맨 위)
//   [로고][제목][부제]
//   (남는 공백)
//   [광고]
//   공백 20%(화면 맨 아래)
// 로고/텍스트/광고 위치를 전부 이 함수 하나에서 화면 크기 기준으로 계산 —
// logoCenter/textBlock의 정적 top:'30%' 스타일은 더 이상 쓰지 않고 여기서 나온
// 값을 인라인으로 덮어씀(두 군데서 서로 다른 기준으로 계산하면 다시 어긋나기 쉬움).
// "남는 공백"은 고정 비율이 아니라 문자 그대로 "로고+텍스트, 광고를 제외하고
// 남는 만큼" — 화면이 길면 넉넉해지고 짧으면 좁아짐. 다만 너무 좁아지면(예:
// iPhone SE류) 광고를 살짝 줄여서라도 최소 여백(20px)은 항상 보장한다.
function useSplashLayout(screenWidth, screenHeight) {
  const topMargin = screenHeight * 0.2;
  const bottomMargin = screenHeight * 0.2;
  const logoTop = topMargin; // 로고 "윗변" 위치(화면 맨 위 공백 20% 바로 다음)
  const textTop = logoTop + LOGO_SIZE + 20; // 로고 아래 여백 20 + 텍스트 시작
  const textHeight = 56; // wordmark+tagline 높이 추정치(10% 축소된 폰트 기준)
  const textBottom = textTop + textHeight;
  const adBottomLimit = screenHeight - bottomMargin; // 광고가 이 선을 넘으면 안 됨
  const minGap = 20; // 텍스트~광고 사이 최소 여백(이보다 좁아지면 광고를 줄임)
  const spaceForGapAndAd = adBottomLimit - textBottom;

  let adWidth = screenWidth * 0.7;
  let adHeight = adWidth * 9 / 16;
  let gap;
  if (spaceForGapAndAd - minGap < adHeight) {
    // 공간이 부족하면 최소 여백은 지키고 광고 쪽을 줄인다(비율 16:9 유지)
    adHeight = Math.max(0, spaceForGapAndAd - minGap);
    adWidth = adHeight * 16 / 9;
    gap = minGap;
  } else {
    gap = spaceForGapAndAd - adHeight; // 자연스럽게 남는 만큼("남는 공백")
  }
  const showAd = adHeight >= 20;
  const adTop = textBottom + gap;

  return {
    logoCenterY: logoTop + LOGO_SIZE / 2, // logoCenter의 top(중앙정렬 앵커라 중심 y좌표)
    textTop,
    ad: showAd ? { top: adTop, width: adWidth, height: adHeight } : null,
  };
}

// 80차 후속: [버그 수정] PICK 광고 박스 전용 — pickImageUrl이 준비된 시점에만 마운트되므로
// (부모의 {pickImageUrl && layout.ad && <PickAdBox .../>} 조건부 렌더), 이 컴포넌트 자신의
// 마운트 시점을 기준으로 스스로 페이드인한다. 하드컷 팝업 대신 부드럽게 나타나게 하는 게
// 목적이라 애니메이션은 짧게(220ms).
function PickAdBox({ url, adLayout }) {
  const opacity = useRef(new Animated.Value(0)).current;
  useEffect(() => {
    Animated.timing(opacity, { toValue: 1, duration: 220, useNativeDriver: true }).start();
  }, [opacity]);
  return (
    <Animated.View
      style={[s.pickAd, { top: adLayout.top, width: adLayout.width, height: adLayout.height, opacity }]}
      pointerEvents="none"
    >
      <ExpoImage source={{ uri: url }} style={s.pickAdImg} contentFit="cover" />
    </Animated.View>
  );
}

// 80차 후속: [버그 수정, 실기기 재신고 — "스플래시화면 2개가 튀어"] 네이티브 스플래시는
// 항상 화면 정중앙(50%)에 로고를 고정하고, App.js의 SplashScreen.hideAsync()는 이
// 컴포넌트가 처음 커밋되는 즉시(useEffect, 첫 렌더 직후) 실행됨 — 즉 네이티브가 사라지는
// 시점엔 이미 이 컴포넌트가 최종 위치(화면 위쪽 20% 지점)에 로고를 그려둔 상태라, 두
// 위치의 차이만큼 로고가 순간이동하듯 튀어 보였음(실기기 스크린샷으로 재현 확인). 최종
// 위치를 처음부터 그리는 대신, "네이티브와 똑같은 정중앙"에서 시작해 최종 위치로 부드럽게
// 슬라이드하는 애니메이션으로 전환 — 네이티브가 사라지는 순간 이 컴포넌트도 정확히 같은
// 자리에 있으므로 컷 없이 이어지고, 그 다음 이동은 "의도된 연출"로 보임. top/marginTop은
// useNativeDriver를 못 써서 transform:translateY만 애니메이션(로고의 top은 최종 위치에
// 고정해두고, 시작 시점엔 그 최종 위치에서 화면 정중앙까지의 오프셋만큼 반대로 밀어둠).
// 텍스트/광고는 로고가 어느 정도 자리잡은 뒤 페이드인 — 로고 이동 중에 갑자기 팝업하지
// 않도록.
// 80차 후속: [버그 수정] App.js(폰트로딩 게이트/인증로딩 게이트)와 navigation/index.js
// (AppNavigator 로딩 게이트, 탈퇴계정 게이트)가 각자 별개 트리 위치에서 이 컴포넌트를
// 마운트해서, 부팅 과정에 여러 게이트를 거칠 때마다 매번 새 인스턴스가 만들어져
// 위 슬라이드 인 애니메이션이 그때마다 처음부터 다시 재생됨 — 디자인은 똑같은데
// 같은 애니메이션이 반복 재생되는 게 "스플래시가 두 번 뜬다"는 신고의 원인이었음.
// 앱 프로세스 생존 기간 동안 한 번만 재생하도록 모듈 스코프 플래그로 기억 — 이후
// 마운트되는 인스턴스는 애니메이션 없이 바로 최종 상태로 렌더(위치·모양은 동일해서
// 화면상 끊김 없이 하나의 스플래시가 쭉 이어지는 것처럼 보임).
let introPlayed = false;

export default function SplashLoadingScreen() {
  const pickImageUrl = usePickAdImage();
  const { width: screenWidth, height: screenHeight } = useWindowDimensions();
  const layout = useSplashLayout(screenWidth, screenHeight);
  const progress = useRef(new Animated.Value(introPlayed ? 1 : 0)).current;
  useEffect(() => {
    if (introPlayed) return;
    // 80차 후속: [버그 수정, fork로 발견] introPlayed를 애니메이션 완료 콜백(.start(()=>...))
    // 에서 세우면, 시작~완료 사이 500ms 창 안에 또 다른 인스턴스가 마운트될 경우 여전히
    // introPlayed===false로 보여 다시 처음부터 재생됨(정확히 이 플래그가 막으려던 "두 번
    // 뜨는" 버그가 재발) — 지금은 useMinSplashHold(3000)가 500ms보다 훨씬 커서 실제로는
    // 이 창에 걸릴 일이 없어 우연히 안전하지만, 그 값이 나중에 줄어들거나 더 이른 게이트가
    // 생기면 조용히 재발할 수 있는 암묵적 전제였음 — 애니메이션 시작 시점에 동기적으로
    // 세워 이 전제 자체를 없앰.
    introPlayed = true;
    Animated.timing(progress, { toValue: 1, duration: 500, useNativeDriver: true }).start();
  }, [progress]);
  // 80차 후속: [버그 수정, fork로 발견] nativeCenterOffset을 매 렌더마다 다시 계산하면,
  // 애니메이션이 아직 진행 중인데(0~500ms) 그 사이 다른 이유(예: pickImageUrl 도착)로
  // 리렌더가 일어나 useWindowDimensions()가 조금이라도 다른 값을 보고하면(안드로이드
  // 부팅 초반 인셋이 안정화되는 과정에서 실제로 있을 수 있음, 이 파일 위쪽 주석에 이미
  // 여러 번 기록된 종류의 불안정성) 이미 진행 중인 interpolate의 출력 범위 자체가
  // 바뀌어버려 로고가 갑자기 다른 지점으로 튀는 잔여 글리치가 생길 수 있었음 — "네이티브
  // 스플래시와 같은 시작점"이라는 값은 원래도 마운트 시점에 딱 한 번만 정해져야 하는
  // 값이므로, useRef로 최초 계산값에 고정(최종 위치 자체(layout.logoCenterY)는 계속
  // 최신값을 따라가야 하니 그건 그대로 둠 — 시작 오프셋만 고정).
  const nativeCenterOffsetRef = useRef(null);
  if (nativeCenterOffsetRef.current === null) {
    nativeCenterOffsetRef.current = screenHeight / 2 - layout.logoCenterY;
  }
  const nativeCenterOffset = nativeCenterOffsetRef.current;
  const logoTranslateY = progress.interpolate({ inputRange: [0, 1], outputRange: [nativeCenterOffset, 0] });
  const restOpacity = progress.interpolate({ inputRange: [0, 0.4, 1], outputRange: [0, 0, 1] });
  return (
    <View style={s.container}>
      <Image
        source={require('../../../assets/splash-texture.png')}
        style={s.texture}
        resizeMode="repeat"
      />
      <Animated.View
        style={[s.logoCenter, { top: layout.logoCenterY, transform: [{ translateY: logoTranslateY }] }]}
        pointerEvents="none"
      >
        <LogoMark size={LOGO_SIZE} />
      </Animated.View>
      <Animated.View style={[s.textBlock, { top: layout.textTop, opacity: restOpacity }]} pointerEvents="none">
        {/* 80차 후속: [버그 수정, 웹에서 특히 눈에 띔] fontsReady로 fontFamily를 켰다 끄던
            방식(72차) 자체가, 이 컴포넌트가 떠 있는 동안 fontsReady가 false→true로
            바뀌면(App.js의 폰트로딩 게이트가 fontsReady={fontsLoaded}를 넘김) 정확히
            그 순간 시스템 기본폰트(가늘어 보임)→FONTS.brand(SpaceGrotesk 700, 굵음)로
            화면에 뜬 채로 글씨체가 바뀌는 원인이었음 — 네이티브는 커스텀 폰트가 앱
            번들에 내장돼 있어 이 전환이 순식간이라 거의 안 보였지만, 웹은 브라우저가
            폰트 파일을 실제로 내려받아야 해서 이 창이 눈에 띄게 길어짐. 커스텀 폰트
            의존 자체를 없애고 fontWeight만으로 처음부터 끝까지 동일하게 굵게 그려서
            폰트 로딩 타이밍과 무관하게 만듦(더 이상 fontsReady를 안 써도 됨). */}
        <Text style={s.wordmark}>UNLOCK</Text>
        <Text style={s.tagline}>방탈출의 모든 것, 하나의 열쇠로</Text>
      </Animated.View>
      {/* 80차 후속: [실기기 재신고] "박스를 항상 먼저 그려두고 사진만 나중에 채우는" 방식이
          정반대 문제를 만들었음 — 사진이 늦게 뜨는 동안 빈 테두리 박스가 계속 보여서
          오히려 "뭔가 멈춰있다/앱이 느리다"는 인상을 줌. 박스(테두리 포함)를 pickImageUrl이
          준비된 순간에만 렌더하도록 원복.
          80차 후속: [버그 수정, fork로 발견] 다만 이 원복만으로는 "박스가 통째로 팝업하면
          깜빡임처럼 보인다"는 애초의 문제(introPlayed가 막는 건 "컴포넌트 재마운트로 인한
          애니메이션 재생"이지, "같은 마운트 안에서 pickImageUrl이 null→URL로 바뀌며 박스가
          하드컷으로 나타나는 것"은 별개 문제라 introPlayed와 무관하게 여전히 발생함)가
          그대로 재발할 수 있었음 — PickAdBox를 별도 컴포넌트로 분리해 자기 자신이
          마운트되는 순간(=pickImageUrl이 막 준비된 그 순간) 스스로 페이드인하도록 함.
          박스 자체가 늦게 나타나는 건 유지하면서(요청사항), 나타날 때는 하드컷이 아니라
          부드럽게 나타나 팝업처럼 안 보이게. */}
      {pickImageUrl && layout.ad && <PickAdBox url={pickImageUrl} adLayout={layout.ad} />}
    </View>
  );
}

const s = StyleSheet.create({
  container: { flex: 1, backgroundColor: COLORS.bg },
  texture: { ...StyleSheet.absoluteFillObject, opacity: 0.04 },
  // 80차 후속: [디자인 변경] 로고/텍스트/광고 위치를 전부 useSplashLayout()이 계산해
  // top을 인라인으로 넘겨줌(공백 20%(위)/20%(아래) + 남는 공백 구조, 사용자가 그려준
  // 스펙) — 여기 남은 top/marginTop은 그 계산과 어긋나지 않는 "중앙정렬 보정"용뿐이라
  // 절대 별도로 %값을 다시 넣지 말 것(두 군데서 각자 계산하면 다시 어긋남).
  // 79차의 "네이티브 스플래시와 위치를 맞춰 전환 시 점프 방지" 원칙과는 이미 상충 —
  // 네이티브 스플래시(app.config.js, 항상 화면 정중앙 고정)는 위치 조정이 안 돼
  // 네이티브→JS 전환 순간 로고가 이동하는 게 보일 수 있음(사용자가 이 트레이드오프를
  // 인지한 채 진행 중).
  logoCenter: {
    position: 'absolute', left: '50%',
    width: LOGO_SIZE, height: LOGO_SIZE, marginLeft: -LOGO_SIZE / 2, marginTop: -LOGO_SIZE / 2,
    alignItems: 'center', justifyContent: 'center',
  },
  textBlock: {
    position: 'absolute', left: 0, right: 0, alignItems: 'center',
  },
  // 80차 후속: [디자인 변경] 로고·제목·부제 10% 축소(사용자 요청) — 30→27, 12.5→11.3.
  wordmark: { fontSize: 27, color: COLORS.gold, letterSpacing: 6.3, fontWeight: '800' },
  tagline: { marginTop: 10, fontSize: 11.3, color: COLORS.textMuted },
  // 80차 후속: [버그 수정] `bottom:155`(화면 하단 기준 고정값)로 두면, textBlock은
  // `top:40%`(화면 높이 기준 %)로 위에서부터 내려오는 앵커라서 화면이 짧은 기기에서는
  // 태그라인 아래쪽과 겹칠 수 있었음(짧은 화면일수록 위/아래 두 앵커가 서로를 향해
  // 가까워짐) — pickAd도 textBlock과 동일하게 top:40% 기준으로, 로고 반지름+텍스트
  // 블록 높이 추정치+여백을 marginTop으로 더해 "항상 텍스트 바로 아래"에 오도록
  // 화면 높이와 무관한 고정 간격을 보장. 폭도 180(고정)→70%로, 높이는 고정값 대신
  // aspectRatio로 폭에 비례하게 해서 어떤 화면 너비에서도 비율이 유지되게 함.
  // 80차 후속: top/width/height는 useSplashLayout()이 화면 크기에 맞춰 매번 계산해
  // 인라인으로 덮어씀 — 여기 남은 건 크기와 무관한 순수 장식(테두리·모서리)뿐.
  pickAd: {
    position: 'absolute', alignSelf: 'center',
    borderRadius: 14, overflow: 'hidden', borderWidth: 1, borderColor: 'rgba(216,174,82,0.35)',
    // 80차 후속: 사진이 도착하기 전 빈 박스가 완전 투명(배경 그대로)이면 허전해 보여서
    // 테두리와 톤을 맞춘 옅은 배경 추가 — 사진이 뜨면 어차피 덮여서 안 보임.
    backgroundColor: 'rgba(216,174,82,0.08)',
  },
  pickAdImg: { width: '100%', height: '100%' },
});
